import { IDatasource, IDatasourceReportFn } from 'core-ts-types';
import * as moment from 'moment';
import { INativeTimeSlot } from '../types/appointment_interfaces';

export interface IAppointmentsAvailableTimesDatasource {
  availableTimes: INativeTimeSlot[];
  beginTimes: moment.Moment[];
  selectedTime: INativeTimeSlot;
  walkInTimesEnabled: boolean;
  requestAppointmentEnabled: boolean;
  isBlockedFromScheduling: boolean;
  blockedFromSchedulingMessage: string;
  isSendEmail: boolean;
  isSendText: boolean;
}

export class AppointmentsAvailableTimesDatasource implements IDatasource {
  private _source: IAppointmentsAvailableTimesDatasource = {
    availableTimes: [],
    beginTimes: [],
    selectedTime: {} as INativeTimeSlot,
    walkInTimesEnabled: false,
    requestAppointmentEnabled: false,
    isBlockedFromScheduling: false,
    blockedFromSchedulingMessage: '',
    isSendEmail: false,
    isSendText: false
  };

  constructor(private $stateParams: any) {
    this.initialize();
  }

  initialize(): AppointmentsAvailableTimesDatasource {
    this._source = {
      availableTimes: [],
      beginTimes: [],
      selectedTime: {} as INativeTimeSlot,
      walkInTimesEnabled: false,
      requestAppointmentEnabled: false,
      isBlockedFromScheduling: false,
      blockedFromSchedulingMessage: '',
      isSendEmail: false,
      isSendText: false
    };
    return this;
  }

  write(raw: any, campaignBeginDate: number = 0): AppointmentsAvailableTimesDatasource {
    const beginDate = campaignBeginDate || this.$stateParams.campaignBeginDate || 0;
    let beginTimes: moment.Moment[] = [];
    const availableTimes: INativeTimeSlot[] = _.filter(
      _.values<INativeTimeSlot>(raw.appointment_times),
      (time: INativeTimeSlot) => time.begin_time > beginDate
    );
    beginTimes = _.map(availableTimes, (time: INativeTimeSlot) => {
      return moment.unix(time.begin_time);
    });
    this._source = {
      availableTimes,
      beginTimes,
      selectedTime: {} as INativeTimeSlot,
      walkInTimesEnabled: raw.show_walk_in_times,
      requestAppointmentEnabled: raw.allow_request_advising_appointment,
      isBlockedFromScheduling: raw.is_blocked_from_scheduling,
      blockedFromSchedulingMessage: raw.blocked_from_scheduling_message,
      isSendEmail: raw.email_reminder,
      isSendText: raw.sms_reminder
    };
    return this;
  }

  setSelectedTime(time: INativeTimeSlot): void {
    this._source.selectedTime = time;
  }

  read(): IAppointmentsAvailableTimesDatasource {
    return this._source;
  }

  clear(): void {
    this.initialize();
  }

  report(fn: IDatasourceReportFn): any[] {
    return fn(this._source);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/datasources/appointments_available_times_datasource.ts